type DeviceType = "mobile" | "desktop";

const DEVICE_TYPE_COOKIE = "seer-device-type";
const MOBILE_VIEWPORT_QUERY = "(max-width: 767px)";
const SWITCH_DEBOUNCE_MS = 300;

export default defineNuxtPlugin(nuxtApp => {
	const mediaQuery = window.matchMedia(MOBILE_VIEWPORT_QUERY);
	const renderedDeviceType = nuxtApp.$deviceType as DeviceType;
	let switchTimer: ReturnType<typeof setTimeout> | null = null;

	const getViewportDeviceType = (): DeviceType => (mediaQuery.matches ? "mobile" : "desktop");

	const clearSwitchTimer = () => {
		if (switchTimer === null) return;
		clearTimeout(switchTimer);
		switchTimer = null;
	};

	const reloadForDevice = (deviceType: DeviceType) => {
		if (deviceType === renderedDeviceType) return;

		// 让刷新后的 SSR 使用当前视口，而不是只依赖浏览器 User-Agent。
		document.cookie = `${DEVICE_TYPE_COOKIE}=${deviceType}; Path=/; SameSite=Lax`;
		document.documentElement.setAttribute("data-device", deviceType);
		window.location.reload();
	};

	const scheduleDeviceSwitch = () => {
		clearSwitchTimer();
		const nextDeviceType = getViewportDeviceType();
		if (nextDeviceType === renderedDeviceType) return;

		switchTimer = setTimeout(() => {
			switchTimer = null;
			reloadForDevice(nextDeviceType);
		}, SWITCH_DEBOUNCE_MS);
	};

	const addListener = () => {
		if (typeof mediaQuery.addEventListener === "function") {
			mediaQuery.addEventListener("change", scheduleDeviceSwitch);
			return;
		}
		mediaQuery.addListener(scheduleDeviceSwitch);
	};

	const removeListener = () => {
		clearSwitchTimer();
		if (typeof mediaQuery.removeEventListener === "function") {
			mediaQuery.removeEventListener("change", scheduleDeviceSwitch);
			return;
		}
		mediaQuery.removeListener(scheduleDeviceSwitch);
	};

	nuxtApp.hook("app:mounted", () => {
		addListener();
		// 兼容打开设备模拟器后再刷新、但 User-Agent 没有同步变化的情况。
		scheduleDeviceSwitch();
	});

	if (import.meta.hot) {
		import.meta.hot.dispose(removeListener);
	}
});
